<template>
  <div>
    <ElButton
      icon="el-icon-edit"
      size="small"
      plain
      class="app-releases-table__button app-releases-table__edit"
      @click="openModal('editModal')"
    >
      {{ $t('APP.RELEASES.EDIT') }}
    </ElButton>

    <EditReleaseModal v-model="editModal" :release="release" />
  </div>
</template>

<script>
import EditReleaseModal from './EditReleaseModal';
import modal from '@/mixins/modal';

export default {
  name: 'EditReleaseButton',
  components: { EditReleaseModal },
  mixins: [modal],
  props: {
    release: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editModal: false,
    };
  },
};
</script>
